import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Project } from 'projects/app-misc/src/app/modules/project-misc/data/project/project';
import { Subject, timer } from 'rxjs';
import {
  ProjectCostRatio,
  ReportsFilter,
  ReportsService
} from 'projects/app-misc/src/app/modules/reports/data/reports.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import {
  PdfPreviewDialogComponent
} from 'projects/app-misc/src/app/modules/project-misc/view/pdf-preview-dialog/pdf-preview-dialog.component';
import { OverallReport, ReportLine } from 'projects/app-misc/src/app/modules/reports/data/overall-report-page';
import {
  ProjectWindowComponent
} from 'projects/desktop/src/app/modules/project/view/project-window/project-window.component';
import { ProjectInfoComponent } from 'projects/mobile/src/app/modules/project/view/project-info/project-info.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import {
  CreateProjectReportDialogComponent
} from 'projects/app-misc/src/app/modules/reports/view/project-overall-price-view/create-project-report-dialog/create-project-report-dialog.component';
import { ConfirmationService } from 'primeng/api';
import moment from 'moment';

@Component({
  selector: 'app-project-overall-price-view',
  templateUrl: './project-overall-price-view.component.html',
  styleUrls: ['./project-overall-price-view.component.scss'],
  providers: [DeviceDetectorService, ConfirmationService]
})
export class ProjectOverallPriceViewComponent implements OnInit, OnDestroy, AfterViewInit {
  allProjs: Project[]
  selectedProjs: Project

  openedReports = []

  overallReports: OverallReport[];

  reportsLoading: boolean

  totalRecords: number;

  saveLoading = -1;
  deleteLoading = -1;

  searchString = '';

  loadSubj = new Subject<void>();

  saveSubj = new Subject<void>();

  repElemsCount = 15;

  reportsFilter: ReportsFilter = {};

  ratesLoading: boolean

  rates: ProjectCostRatio;

  reportFromDate: Date;
  reportToDate = new Date();

  constructor(
    private dialog: MatDialog,
    public router: Router,
    protected confirmationService: ConfirmationService,
    protected deviceDetectorService: DeviceDetectorService,
    private reportsService: ReportsService,
    private el: ElementRef
  ) {
  }

  ngOnInit(): void {
    this.reportsLoading = true;
    this.ratesLoading = true

  }

  ngAfterViewInit() {
    timer(1).subscribe(emit => {
      this.repElemsCount = Math.max(this.repElemsCount, Math.trunc((this.el.nativeElement.offsetHeight - 200) / 45));

      this.getReportsLazy(0, this.repElemsCount)
      this.subToSearch();
      this.getRatio()

      this.subToSave();
    })
  }

  getRatio() {
    this.ratesLoading = true
    this.reportsService.getReportRates().subscribe(rates => {
      this.rates = rates

      this.ratesLoading = false
    })
  }

  subToSave() {
    this.saveSubj.pipe(debounceTime(500)).subscribe(emit => {
      this.reportsService.updateProjectCostRatio(this.rates).subscribe(res => {

      })
    })
  }

  addLine(item: ReportLine, index: number) {
    if(this.overallReports[index]) {
      this.overallReports[index].items.push(item)
    }
  }

  itemEdited(index) {
    if(this.overallReports[index]) {
      this.overallReports[index].totalCost = 0;
      this.overallReports[index].items.forEach(item => {
        this.overallReports[index].totalCost += item.totalPrice >= 0 ? item.totalPrice : 0
      })
    }
  }

  subToSearch() {
    this.loadSubj.pipe(debounceTime(500)).subscribe(emit => {
      this.reportsFilter.query = this.searchString;
      this.reportFromDate = null;
      this.reportToDate = new Date()

      this.getReportsLazy(0, this.repElemsCount)
    })
  }

  dateChange() {
    if(!this.reportFromDate) {
      this.reportFromDate = moment('01-01-2017', 'MM-DD-YYYY').toDate()
    }
    if(!this.reportToDate) {
      this.reportToDate = moment().toDate()
    }
    this.getReportsLazy(0, this.repElemsCount)
  }

  topSearchBar() {
    this.loadSubj.next()
  }

  topRationBarLabor(event) {
    this.rates.value.directLaborCost = event.value
    this.saveSubj.next()
  }

  topRationBarOverhead(event) {
    this.rates.value.overheadLaborCost = event.value
    this.saveSubj.next()
  }

  getReportsLazy(page: number, rows: number, action?: string) {
    if(this.reportFromDate) {
      this.getFilteredReportsLazy(page, rows)
      return
    }

    this.openedReports = [];
    this.reportsLoading = true;

    this.reportsFilter.start = page;
    this.reportsFilter.limit = rows;

    this.reportsService.searchProjectReports(this.reportsFilter).subscribe(reps => {
      this.overallReports = reps.content
      this.totalRecords = reps.totalElements;

      if(action && action === 'NEW') {
        this.openedReports = [0]
      }
      this.reportsLoading = false;
    })
  }

  getFilteredReportsLazy(page: number, rows: number) {
    this.openedReports = [];
    this.reportsLoading = true;

    this.reportsFilter.start = page;
    this.reportsFilter.limit = rows;
    this.reportsFilter.fromDate = moment(this.reportFromDate).format('YYYY-MM-DD')
    this.reportsFilter.toDate = moment(this.reportToDate).format('YYYY-MM-DD')

    this.reportsService.filterProjectReports(this.reportsFilter).subscribe(reps => {
      this.overallReports = reps.content
      this.totalRecords = reps.totalElements;

      this.reportsLoading = false;
    })
  }


  updateDate(report: OverallReport, index: number) {

    this.saveLoading = report.id;

    this.reportsService.updateProjectReport(report).subscribe(newRep => {
      // report = newRep
      this.overallReports[index].items = newRep.items
      this.saveLoading = -1;
    }, error => {
      this.saveLoading = -1;
    })
  }

  openReport(report: OverallReport, index: number) {
    this.saveLoading = report.id;

    this.reportsService.updateProjectReport(report).subscribe(newRep => {
      this.overallReports[index].items = newRep.items

      const cpDialogRef = this.dialog.open(PdfPreviewDialogComponent, {
        data: {
          dialogHeader: `${report.projectDTO.name} - Cost Report`,
          link: `/project-cost/${report.id}/pdf`,
          showSendButton: true
        },
        panelClass: 'pdf-preview-dialog'
      });

      this.saveLoading = -1;
    }, error => {
      this.saveLoading = -1;
    })

  }

  createReport() {
    const dialogRef = this.dialog.open(CreateProjectReportDialogComponent, {
      disableClose: false,
      panelClass: 'project-activity-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result && result[0] === 'success') {
        this.reportFromDate = null;
        this.reportToDate = new Date()
        this.getReportsLazy(0, this.repElemsCount, 'NEW')
      }
    });
  }

  resetSearch() {
    this.searchString = '';
    this.reportsFilter.query = '';
    this.reportFromDate = null;
    this.reportToDate = new Date()

    this.getReportsLazy(0, this.repElemsCount)
  }

  openProject(projectId: number) {
    let projectWindow = ProjectWindowComponent as any;
    let panelClass = 'project-window-dialog'

    if(this.deviceDetectorService.isMobile() || this.deviceDetectorService.isTablet()) {
      projectWindow = ProjectInfoComponent
      panelClass = 'project-info-dialog'
    }

    const dialogRef = this.dialog.open(projectWindow, {
      data: {
        projectNumber: projectId
      },
      panelClass
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  deleteReport(report: OverallReport, index: number) {

    this.confirmationService.confirm({
      header: 'Delete Report?',
      message: `Delete report for project ${report.projectDTO.name}?`,
      accept: () => {
        this.deleteLoading = report.id;

        this.reportsService
        .deleteReport(report.id)
        .subscribe(emit => {

            let tempSet = new Set()
            this.openedReports.forEach(i => {
              if(i !== index) {
                tempSet.add(this.overallReports[i].id)
              }
            })

            this.overallReports.splice(index, 1)
            this.openedReports = []

            this.overallReports.forEach((rep, i) => {
              if(tempSet.has(rep.id)) {
                this.openedReports.push(i)
              }
            })

            this.deleteLoading = -1;
          },
          error => {
            this.deleteLoading = -1;
          })
      }
    });
  }

  openTab(event) {
    this.openedReports.push(event.index)
  }

  closeTab(event) {
    const openedOrder = this.openedReports.findIndex(i => i === event.index)

    if(openedOrder >= 0) {
      this.openedReports.splice(openedOrder, 1)
    }
  }

  focusInput(event) {
    let input = (event.target as HTMLInputElement);
    input.focus()
    input.setSelectionRange(0, input.value.length);
  }

  ngOnDestroy() {
    this.saveSubj.unsubscribe()
    this.loadSubj.unsubscribe()
  }

  blurActiveElement() {
    setTimeout(() => {
      let activeElement = document.activeElement;
      if (activeElement && activeElement instanceof HTMLElement)
        activeElement.blur()
    }, 5);
  }


}
